import { render, staticRenderFns } from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=template&id=b2f5f5e2&scoped=true&"
import script from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=script&lang=ts&"
export * from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=script&lang=ts&"
import style0 from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=style&index=0&id=b2f5f5e2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f5f5e2",
  null
  
)

export default component.exports